import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import querySearch from 'stringquery';
import { useLocation } from 'react-router-dom';
import { appNames, SlackAppType } from 'utils/slack-app-names';
import { CelebrationInstructions } from 'app/components/CelebrationInstructions';
import { IcebreakerInstructions } from 'app/components/IcebreakerInstructions';
import { IntrosInstructions } from 'app/components/IntrosInstructions';
import { CoffeeTalkOnboarding } from '../CoffeeTalkOnboarding/Loadable';
import { MapsInstructions } from 'app/components/MapsInstructions';
import { ShoutoutInstructions } from 'app/components/ShoutoutInstructions';
import { Helmet } from 'react-helmet-async';
import { useCookies } from 'react-cookie';

const MainContent = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.5s ease-in;
  @media (max-width: 768px) {
    padding-bottom: 10%;
    min-height: 550px;
    padding: 1em;
  }
`;

export function InstallationInstruction() {
  const [cookies, _] = useCookies(['utm_campaign', 'utm_source', 'utm_medium']);
  const [utm, setUtm] = useState<string | undefined>();
  const [slackApp, setSlackApp] = useState<SlackAppType>('celebrations');
  const location = useLocation();
  useEffect(() => {
    handleAppQuery();
  }, []);

  const handleAppQuery = () => {
    const hash = querySearch(location.search);
    if (!!hash) {
      const appName = hash['app'];
      if (appNames.includes(appName)) {
        setSlackApp(appName);
      }
    }
    const utmCampaign = cookies.utm_campaign;
    if (!!utmCampaign) {
      setUtm(
        `${utmCampaign};${cookies.utm_source || ''};${
          cookies.utm_medium || ''
        }`,
      );
    }
  };

  return (
    <>
      <Helmet>
        <meta property="robots" content="noindex" />
      </Helmet>
      <div>
        <MainContent>
          {slackApp === 'celebrations' && <CelebrationInstructions utm={utm} />}
          {slackApp === 'icebreakers' && <IcebreakerInstructions utm={utm} />}
          {slackApp === 'intros' && <IntrosInstructions utm={utm} />}
          {slackApp === 'coffee-talk' && <CoffeeTalkOnboarding utm={utm} />}
          {slackApp === 'maps' && <MapsInstructions utm={utm} />}
          {slackApp === 'shoutouts' && <ShoutoutInstructions utm={utm} />}
        </MainContent>
      </div>
    </>
  );
}
